import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Company = forwardRef<SVGSVGElement | null, IconFilledProps>(function Company({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7 6V3.5C7 2.39543 7.89543 1.5 9 1.5H15C16.1046 1.5 17 2.39543 17 3.5V6H20C21.1046 6 22 6.89543 22 8V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V8C2 6.89543 2.89543 6 4 6H7ZM9 3H15C15.2761 3 15.5 3.22386 15.5 3.5V6H8.5V3.5C8.5 3.22386 8.72386 3 9 3ZM4 7.5C3.72386 7.5 3.5 7.72386 3.5 8V19C3.5 19.2761 3.72386 19.5 4 19.5H20C20.2761 19.5 20.5 19.2761 20.5 19V8C20.5 7.72386 20.2761 7.5 20 7.5H4Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7 6V3.5C7 2.39543 7.89543 1.5 9 1.5H15C16.1046 1.5 17 2.39543 17 3.5V6H20C21.1046 6 22 6.89543 22 8V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V8C2 6.89543 2.89543 6 4 6H7ZM9 3H15C15.2761 3 15.5 3.22386 15.5 3.5V6H8.5V3.5C8.5 3.22386 8.72386 3 9 3Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'company-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Company;
